import React from 'react';

export const IconHeartFilled = props => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5 2.00732C3.06497 2.00732 1.5 3.58218 1.5 5.52031C1.5 6.03911 1.58372 6.4971 1.79018 6.93982C1.99287 7.37444 2.30023 7.76482 2.70411 8.1694L8.00003 13.7813L13.292 8.17265C13.8619 7.60076 14.5 6.62517 14.5 5.52031C14.5 3.58218 12.935 2.00732 11 2.00732C9.55894 2.00732 8.57666 2.86818 8.00249 3.99599C7.42847 2.86041 6.44408 2.00732 5 2.00732Z"
        fill="currentColor"
      />
    </svg>
  );
};
